<template>
  <div style="height:100%">
    <ul id="lycontainer">
      <li
        class="ele"
        :draggable="true"
        v-for="(item, index) in list"
        :key="index"
      >
        {{ item.name }}
      </li>
    </ul>
    <Button type="primary" @click="getResult" long>确定排序</Button>
  </div>
</template>
<script>
export default {
  props: ["data"],
  data() {
    return {
      list: [],
    };
  },
  methods: {
    reach(v) {
      this.list = v;
    },
    start() {
      var node = document.querySelector("#lycontainer");
      var draging = null;
      var that = this;

      //使用事件委托，将li的事件委托给ul
      node.ondragstart = function (event) {
        //console.log("start");
        //firefox设置了setData后元素才能拖动！！！！
        //event.target出发事件的元素
        event.dataTransfer.setData("te", event.target.innerText); //不能使用text，firefox会打开新tab
        //event.dataTransfer.setData("self", event.target);
        draging = event.target;
      };

      node.ondragover = function (event) {
        //取消默认行为
        event.preventDefault();
        var target = event.target;
        //因为dragover会发生在ul上，所以要判断是不是li
        if (target.nodeName === "LI") {
          if (target !== draging) {
            //getBoundingClientRect()用于获取某个元素相对于视窗的位置集合
            var targetRect = target.getBoundingClientRect();
            var dragingRect = draging.getBoundingClientRect();
            if (target) {
              if (target.animated) {
                return;
              }
            }

            var b = JSON.parse(JSON.stringify(that.list));

            if (that._index(draging) < that._index(target)) {
              //nextSibling 属性可返回某个元素之后紧跟的节点（处于同一树层级中）。
              target.parentNode.insertBefore(draging, target.nextSibling);
            } else {
              target.parentNode.insertBefore(draging, target);
            }
            that.list[that._index(draging)] = b[that._index(target)];
            that.list[that._index(target)] = b[that._index(draging)];
            that._animate(dragingRect, draging);
            that._animate(targetRect, target);
          }
        }
      };
    },
    //获取元素在父元素中的index
    _index(el) {
      var index = 0;

      if (!el || !el.parentNode) {
        return -1;
      }
      //previousElementSibling属性返回指定元素的前一个兄弟元素（相同节点树层中的前一个元素节点）。
      while (el && (el = el.previousElementSibling)) {
        //console.log(el);
        index++;
      }
      return index;
    },
    _animate(prevRect, target) {
      var ms = 300;

      if (ms) {
        var currentRect = target.getBoundingClientRect();
        //nodeType 属性返回以数字值返回指定节点的节点类型。1=元素节点  2=属性节点
        if (prevRect.nodeType === 1) {
          prevRect = prevRect.getBoundingClientRect();
        }
        this._css(target, "transition", "none");
        this._css(
          target,
          "transform",
          "translate3d(" +
            (prevRect.left - currentRect.left) +
            "px," +
            (prevRect.top - currentRect.top) +
            "px,0)"
        );

        target.offsetWidth; // 触发重绘
        //放在timeout里面也可以
        // setTimeout(function() {
        //     _css(target, 'transition', 'all ' + ms + 'ms');
        //     _css(target, 'transform', 'translate3d(0,0,0)');
        // }, 0);
        this._css(target, "transition", "all " + ms + "ms");
        this._css(target, "transform", "translate3d(0,0,0)");

        clearTimeout(target.animated);
        var that = this;
        target.animated = setTimeout(function () {
          that._css(target, "transition", "");
          that._css(target, "transform", "");
          target.animated = false;
        }, ms);
      }
    },
    //给元素添加style
    _css(el, prop, val) {
      var style = el && el.style;

      if (style) {
        if (val === void 0) {
          //使用DefaultView属性可以指定打开窗体时所用的视图
          if (document.defaultView && document.defaultView.getComputedStyle) {
            val = document.defaultView.getComputedStyle(el, "");
          } else if (el.currentStyle) {
            val = el.currentStyle;
          }

          return prop === void 0 ? val : val[prop];
        } else {
          if (!(prop in style)) {
            prop = "-webkit-" + prop;
          }

          style[prop] = val + (typeof val === "string" ? "" : "px");
        }
      }
    },
    getResult(v) {
      
      this.$emit('result',this.list);
    },
  },
  mounted() {
    this.start();
  },
  
};
</script>
<style>
#lycontainer {
  width: 100%;
  height: calc(100% - 40px);
  margin-bottom: 6px;
  overflow: auto;
}

#lycontainer .ele {
  width: 100%;
  line-height: 34px;
  background-image: linear-gradient(to bottom, #f3f3f3, #ffffff, #eaeaea);
  border-radius: 10px;
  padding-left: 10px;
  cursor: move;
}
</style>


// WEBPACK FOOTER //
// src/components/tangci/handSet.vue